import api, { Header } from '../../base';
import {
  AllegroCreateResponsibleProducerRequest,
  AllegroResponsibleProducer,
  AllegroResponsibleProducers,
  AllegroUpdateResponsibleProducerRequest,
} from './responsibleProducerTypes';
import { mockAllegroResponsibleProducer, mockGetAllegroResponsibleProducers } from './responsibleProducerMocks';

const RESPONSIBLE_PRODUCERS_PATH = 'allegro-api/sale/responsible-producers';

export async function getAllegroResponsibleProducers(
  marketplaceCode: string,
  offset: number = 0,
  limit: number = 1000,
  signal?: AbortSignal,
): Promise<AllegroResponsibleProducers> {
  const response = await api.get<AllegroResponsibleProducers>(
    RESPONSIBLE_PRODUCERS_PATH,
    {
      headers: {
        [Header.X_ESHOP_CODE]: marketplaceCode,
        [Header.ACCEPT]: 'application/vnd.allegro.public.v1+json',
      },
      params: { offset, limit },
      signal,
    },
  );

  return response.data;
}

api.mock
  .onGet('allegro-api/sale/responsible-producers')
  .reply(200, mockGetAllegroResponsibleProducers);

export async function createAllegroResponsibleProducer(
  marketplaceCode: string,
  payload: AllegroCreateResponsibleProducerRequest,
  signal?: AbortSignal,
): Promise<AllegroResponsibleProducer> {
  const response = await api.post<AllegroResponsibleProducer>(
    RESPONSIBLE_PRODUCERS_PATH,
    payload,
    {
      headers: {
        [Header.X_ESHOP_CODE]: marketplaceCode,
        [Header.ACCEPT]: 'application/vnd.allegro.public.v1+json',
        [Header.CONTENT_TYPE]: 'application/vnd.allegro.public.v1+json',
      },
      signal,
    },
  );

  return response.data;
}

api.mock
  .onPost('allegro-api/sale/responsible-producers')
  .reply(200, mockAllegroResponsibleProducer);

export async function updateAllegroResponsibleProducer(
  marketplaceCode: string,
  id: string,
  payload: AllegroUpdateResponsibleProducerRequest,
  signal?: AbortSignal,
): Promise<AllegroResponsibleProducer> {
  const response = await api.put<AllegroResponsibleProducer>(
    `${RESPONSIBLE_PRODUCERS_PATH}/${id}`,
    payload,
    {
      headers: {
        [Header.X_ESHOP_CODE]: marketplaceCode,
        [Header.ACCEPT]: 'application/vnd.allegro.public.v1+json',
        [Header.CONTENT_TYPE]: 'application/vnd.allegro.public.v1+json',
      },
      signal,
    },
  );

  return response.data;
}

api.mock
  .onPut(/allegro-api\/sale\/responsible-producers\/.+/)
  .reply(200, mockAllegroResponsibleProducer);
